import Cookies from 'js-cookie';
import { createStore } from 'vuex';

export default createStore({
  state: {
    currentAccount: {
      id: '',
      unid: '',
      userId: '',
      country: '',
      mobile: '',
      accountName: '',
      realName: '',
      cnic: '',
      headUrl: '',
      email: '',
      birth: '',
      gender: '',
      lng: '',
      lat: '',
      invitationCode: '',
      referralCode: '',
      source: '',
      status: 0, //状态(0:正常、1:冻结、2:注销)
      remark: '',
      isCertified: false, //是否认证(0否、1是)
      balance: 0,
      frozenBal: 0,
      firstName: '',
      lastName: '',
      type: 'seeker',
    },
    token: Cookies.get('token'),
    isStoreInitState: true,
  },
  mutations: {
    setCurrentAccount(state, currentAccount) {
      state.currentAccount = currentAccount;
    },
    setToken(state, token) {
      state.token = token;
    },
    clearToken(state) {
      state.token = null;
    },
  },
  actions: {
    login({ commit }, token) {
      commit('setToken', token);
    },
    logout({ commit }) {
      commit('clearToken');
      commit('setCurrentAccount', {});
    },
  },
  getters: { isAuthenticated: (state) => !!state.token, getToken: (state) => state.token },
});
